// UI chrome translations. PT + EN complete; DE + FR partial with EN fallback.
export const LANGS = ["pt", "en", "de", "fr"];
export const LANG_LABELS = { pt: "PT", en: "EN", de: "DE", fr: "FR" };

const en = {
  "nav.home": "Home",
  "nav.modular": "Modular",
  "nav.energy": "Energy",
  "nav.digital": "Digital",
  "nav.integrated": "Solutions",
  "nav.projects": "Projects",
  "nav.divisions": "Divisions",
  "nav.partners": "Partners",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.solutions": "Solutions",
  "nav.integrated_full": "Integrated Solutions",
  "nav.pilots": "Pilots",
  "nav.caboverde": "Cabo Verde",
  "nav.technology": "Technology",
  "nav.gallery": "Gallery",
  "nav.projectmap": "Project Map",
  "cta.become_partner": "Become a Partner",
  "cta.explore_solutions": "Explore Solutions",
  "cta.know_pilots": "Explore the Pilots",
  "neunexus.positioning": "Local Needs · Global Capabilities · Integrated Projects",
  "neunexus.tagline": "Infrastructure · Technology · Tourism",
  "neunexus.intro": "BSGOTECH connects people, places and opportunities through infrastructure, technology and tourism — structuring real projects with the right partners.",
  "home.pillars.overline": "The 5 Technology Pillars",
  "home.pillars.title": "Five capabilities. One integrated ecosystem.",
  "home.pillars.sub": "Each pillar works on its own — and becomes far more powerful when combined.",
  "home.synergy.overline": "Integrated Solutions",
  "home.synergy.title": "Synergy in action.",
  "home.synergy.sub": "Real infrastructure needs are rarely single-technology. HX ECOSYSTEMS combines pillars into coordinated solutions.",
  "home.validation.overline": "Our Validation Logic",
  "home.validation.title": "Start small. Validate. Measure. Scale.",
  "home.validation.sub": "We prove solutions with real data in pilots before replicating them.",
  "home.pilots.badge": "Pre-Pilot Program · Cabo Verde",
  "home.pilots.title": "3 pilot projects to validate the model.",
  "home.pilots.text": "No project has been executed yet. Impacts shown are validation objectives and hypotheses — quantitative results will be reported only after implementation, monitoring and analysis.",
  "home.partner.overline": "Scalable to Africa",
  "home.partner.title": "Build the green transition with us.",
  "home.partner.text": "BSGOTECH grows through strategic partnerships — technology, institutional, local implementation and investment. Solutions validated in Cabo Verde are replicable across island and African markets.",
  "pillar.explore_more": "Explore the ecosystem.",
  "hero.slide.emobility": "Electric mobility powered by clean energy.",
  "hero.slide.caboverde": "Our focus market to validate the green transition.",
  "cta.discuss": "Discuss a Project",
  "cta.explore": "Explore Solutions",
  "cta.request_assessment": "Request Project Assessment",
  "cta.explore_modular": "Explore Modular",
  "cta.explore_energy": "Explore Energy",
  "cta.explore_digital": "Explore Digital",
  "cta.explore_integrated": "Explore Integrated Solutions",
  "cta.view_project": "View Project",
  "cta.discuss_this": "Discuss This Project",
  "cta.learn_more": "Learn more",
  "tagline": "DIGITAL | MODULAR | ENERGY",
  "brand.primary": "Technology and infrastructure for real-world needs.",
  "brand.support": "Digital systems, modular infrastructure and reliable energy solutions for businesses, communities and growing markets.",
  "home.cap.heading": "Three capabilities. One integrated approach.",
  "subtagline": "Practical infrastructure. Reliable energy. Integrated solutions.",
  "corporate.message": "Building practical solutions for growing markets.",
  "hero.support": "Based in São Tomé and Príncipe, BSGOTECH develops practical modular, energy and integrated solutions by connecting real market needs with specialised international technology, manufacturing, engineering and implementation partners.",
  "home.digital.title": "Technology that connects.",
  "home.digital.text": "Websites · Apps · AI · Cloud · Automation",
  "home.capabilities": "Core Capabilities",
  "home.modular.title": "Infrastructure that adapts.",
  "home.modular.text": "Flexible modular infrastructure designed around practical commercial, community, institutional and operational needs.",
  "home.energy.title": "Reliable power where it matters.",
  "home.energy.text": "Energy generation, storage, backup and integrated power systems configured according to real project requirements.",
  "home.integrated.title": "One project. One coordinated solution.",
  "home.integrated.text": "Infrastructure, energy, technology and implementation combined around a specific project need.",
  "hero.slide.energy": "Reliable energy where it matters.",
  "home.stp.title": "Building from home.",
  "home.stp.text": "São Tomé and Príncipe is BSGOTECH's home market and initial operational base.",
  "process.title": "How BSGOTECH Works",
  "model.title": "Local need + International capability + Local implementation = Practical solution",
  "concept": "Concept Visual",
  "section.overview": "Overview",
  "section.need": "The Need",
  "section.solution": "BSGOTECH Solution",
  "section.applications": "Applications",
  "section.configuration": "Possible Configuration",
  "section.architecture": "Modular Architecture",
  "section.energy": "Energy Integration",
  "section.optional": "Optional Components",
  "section.implementation": "Implementation Process",
  "section.validation": "Technical Validation",
  "section.assessment": "Request Project Assessment",
  "disclaimer.short": "Configuration subject to technical assessment.",
  "disclaimer.long": "Final dimensions, materials, specifications, pricing and implementation schedule depend on project requirements, location, engineering validation and manufacturing partner confirmation.",
  "projects.title": "From concept to implementation.",
  "projects.filter.all": "All",
  "footer.solutions": "Solutions",
  "footer.company": "Company",
  "footer.legal": "Legal",
  "footer.legal_notice": "Legal Notice",
  "footer.imprint": "Imprint",
  "footer.privacy": "Privacy Policy",
  "footer.cookies": "Cookie Policy",
  "footer.faq": "FAQ",
  "footer.terms": "Terms",
  "footer.rights": "All rights reserved.",
  "contact.title": "What do you need to build?",
  "contact.submit": "Submit Project",
  "contact.thankyou": "Thank you. BSGOTECH will review your project requirements and contact you regarding the appropriate next step.",
  "form.name": "Name",
  "form.company": "Company / Organisation",
  "form.country": "Country",
  "form.email": "Email",
  "form.phone": "Phone / WhatsApp",
  "form.looking_for": "I am looking for",
  "form.project_type": "Project type",
  "form.location": "Project Location",
  "form.units": "Estimated Number of Units",
  "form.energy_req": "Energy Requirement",
  "form.stage": "Project Stage",
  "form.budget": "Budget Range",
  "form.timeline": "Target Timeline",
  "form.description": "Project Description",
  "whatsapp.default": "Hello BSGOTECH, I would like to discuss a project.",
  "sec.services": "Services",
  "modular.hero.sub": "Practical spaces. Flexible infrastructure. BSGOTECH develops and configures modular infrastructure solutions with specialised manufacturing, engineering and implementation partners — responding to real local needs rather than generic container products.",
  "modular.vc.overline": "From Design to Delivery",
  "modular.vc.title": "How a BSGOTECH modular solution is delivered.",
  "energy.hero.sub": "Tell us what you need to power. BSGOTECH configures the solution — for homes, businesses and infrastructure — with specialised energy technology and implementation partners.",
  "energy.kits.overline": "BSGOTECH Energy Solutions",
  "energy.kits.title": "Start with what you need to power.",
  "energy.kits.sub": "You do not need to choose inverters or battery capacity first. Choose your situation and BSGOTECH configures and validates the solution.",
  "energy.journey.title": "Tell us what you need to power. BSGOTECH configures the solution.",
  "energy.blocks.overline": "Energy Building Blocks",
  "energy.blocks.title": "The technologies behind the solutions.",
  "energy.apps.title": "Energy where it matters.",
  "energy.partner.overline": "Energy Technology Ecosystem",
  "energy.partner.title": "Specialised technology, coordinated by BSGOTECH.",
  "energy.partner.sub": "MUST Energy appears beneath the BSGOTECH energy offer, as part of the technology and manufacturing ecosystem. BSGOTECH configures the solution; specialised partners supply the technology.",
  "energy.provider.china": "Technology Provider · China",
  "energy.must.role": "Energy Technology / Manufacturing Partner",
  "energy.must.note": "Capabilities reflect the supplier catalogue and relationship. MUST Energy products are not designed in Germany.",
  "energy.chain.1": "Energy Assessment & Solution Configuration",
  "energy.chain.2": "Energy Technology & Manufacturing",
  "energy.chain.3": "International Delivery",
  "energy.chain.4": "Installation · Integration · Support",
  "logistics": "Logistics",
  "delivery.overline": "Request Delivery Estimate",
  "delivery.title": "From assessment to installation.",
  "delivery.note": "Estimated days/weeks are shown only after supplier and logistics confirmation for the specific project. We do not publish fixed manufacturing or shipping times.",
  "ivc.overline": "One International Value Chain",
  "ivc.title": "From design to local delivery.",
  "ivc.intro": "BSGOTECH develops and configures complete solutions and uses specialised international technology and manufacturing partners to deliver them.",
  "ivc.dev": "Development · Integration · Automation",
  "digital.hero.sub": "Technology that connects. BSGOTECH designs and coordinates digital solutions — websites, applications, AI, cloud and automation — delivered with specialised technology partners.",
  "digital.services.title": "Digital, configured around the need.",
  "digital.eco.overline": "Digital Technology Ecosystem",
  "digital.eco.title": "Built with specialised partners.",
  "digital.eco.sub": "BSGOTECH develops and coordinates the solution. Specialised technology partners support delivery.",
  "digital.provider": "Technology Provider",
  "digital.aaban.role": "Technology Partner · Software",
  "digital.aaban.note": "Aaban Solutions is a specialised technology partner and not a BSGOTECH division.",
  "kit.solution.label": "BSGOTECH Energy Solution",
  "kit.arch": "Possible Solution Architecture",
  "kit.assessment": "Assessment",
  "kit.discuss": "Discuss this project",
  "kit.fullkit": "A BSGOTECH Full Energy Kit is a configured solution, not a BSGOTECH-manufactured battery or inverter.",
  "kit.finalsizing": "Final sizing must require technical validation.",
  "kit.infra.text": "Infrastructure energy is configured together with the modular infrastructure. Tell us about your project and BSGOTECH configures the integrated solution.",
  "kit.thankyou": "Thank you. BSGOTECH will review your requirements and contact you with a configured solution. Final sizing requires technical validation.",
  "assess.contact": "WhatsApp / Email",
  "assess.error": "Please provide your name and contact (WhatsApp / Email).",
  "int.hero.l1": "MORE THAN INFRASTRUCTURE.",
  "int.hero.l2": "MORE THAN ENERGY.",
  "int.hero.l3": "ONE COORDINATED SOLUTION.",
  "int.hero.p": "BSGOTECH can configure different components around one project rather than treating infrastructure and energy as completely separate purchases.",
  "int.examples.overline": "Examples",
  "int.examples.title": "Configurable solution architectures.",
  "int.examples.sub": "These are configurable solution architectures, not fixed technical packages.",
  "int.connected.overline": "Connected Solutions",
  "int.connected.title": "Modular + Energy + Digital, together.",
  "int.connected.sub": "Configurable connected architectures — not fixed technical packages.",
  "int.partnermodel.overline": "International Partner Model",
  "int.partnermodel.title": "How capability comes together.",
  "partners.overline": "Partner Ecosystem",
  "partners.hero.title": "BUILT THROUGH SPECIALISED PARTNERSHIPS.",
  "partners.hero.sub": "BSGOTECH's role is to connect the appropriate capabilities around each project rather than claiming to manufacture every component internally.",
  "partners.categories": "Categories",
  "partners.cat.title": "A coordinated ecosystem.",
  "partners.rel.overline": "Relationships",
  "partners.rel.title": "Current partner status.",
  "partners.rel.sub": "Only relationships appropriate for public display are shown. Status reflects the real stage of each conversation.",
  "partners.empty": "No partners published yet.",
  "about.hero.sub": "BSGOTECH is a São Tomé and Príncipe-based company focused on developing practical modular, energy and integrated infrastructure solutions.",
  "about.p1": "Our model combines local market understanding with specialised international manufacturing, engineering, energy and technology capabilities.",
  "about.p2": "From identifying a need through solution configuration, partner coordination and implementation, BSGOTECH seeks to build solutions that are practical, scalable and appropriate to their operating environment.",
  "about.principles.overline": "Principles",
  "about.principles.title": "Five principles.",
  "about.bm.overline": "Business Model",
  "about.bm.title": "Market need to support.",
  "about.ipm.title": "Local + international + local.",
  "about.ipm.p": "Local need + international capability + local implementation = practical solution.",
  "about.germany.overline": "Germany & Europe",
  "about.germany.tag": "Technology · Engineering · Manufacturing · Business Development · Partnerships",
  "about.germany.p": "BSGOTECH can develop relationships with European technology, engineering, manufacturing and commercial partners. BSGOTECH is not a German company and does not maintain a German corporate headquarters.",
  "about.africa.overline": "Selected African Markets",
  "about.africa.tag": "Partner-led growth.",
  "about.africa.p": "BSGOTECH aims to evaluate opportunities in selected African markets based on real market demand, local partners, technical feasibility, commercial viability, financing and implementation capacity.",
  "about.local.overline": "Building Local Capacity",
  "about.local.tag": "A development objective.",
  "about.local.p": "Where technically and commercially viable, BSGOTECH projects can progressively support local installation, assembly, technical training, maintenance capability, supplier participation, skills development and knowledge transfer.",
  "model.need": "LOCAL NEED",
  "model.intl": "INTERNATIONAL CAPABILITY",
  "model.localimpl": "LOCAL IMPLEMENTATION",
  "model.result": "= PRACTICAL SOLUTION",
};

const pt = {
  "nav.home": "Início",
  "nav.modular": "Modular",
  "nav.energy": "Energia",
  "nav.digital": "Digital",
  "nav.integrated": "Soluções",
  "nav.projects": "Projetos",
  "nav.divisions": "Divisões",
  "nav.partners": "Parceiros",
  "nav.about": "Sobre",
  "nav.contact": "Contacto",
  "nav.solutions": "Soluções",
  "nav.integrated_full": "Soluções Integradas",
  "nav.pilots": "Pilotos",
  "nav.caboverde": "Cabo Verde",
  "nav.technology": "Tecnologia",
  "nav.gallery": "Galeria",
  "nav.projectmap": "Mapa de Projetos",
  "cta.become_partner": "Tornar-se Parceiro",
  "cta.explore_solutions": "Explorar Soluções",
  "cta.know_pilots": "Conhecer os Pilotos",
  "neunexus.positioning": "Necessidades Locais · Capacidades Globais · Projetos Integrados",
  "neunexus.tagline": "Infraestrutura · Tecnologia · Turismo",
  "neunexus.intro": "A BSGOTECH liga pessoas, lugares e oportunidades através de infraestrutura, tecnologia e turismo — estruturando projetos reais com os parceiros certos.",
  "home.pillars.overline": "Os 5 Pilares Tecnológicos",
  "home.pillars.title": "Cinco capacidades. Um ecossistema integrado.",
  "home.pillars.sub": "Cada pilar funciona por si — e torna-se muito mais poderoso quando combinado.",
  "home.synergy.overline": "Soluções Integradas",
  "home.synergy.title": "A sinergia em ação.",
  "home.synergy.sub": "As necessidades reais de infraestrutura raramente são de uma só tecnologia. A HX ECOSYSTEMS combina pilares em soluções coordenadas.",
  "home.validation.overline": "A Nossa Lógica de Validação",
  "home.validation.title": "Começar pequeno. Validar. Medir. Escalar.",
  "home.validation.sub": "Provamos as soluções com dados reais em pilotos antes de as replicar.",
  "home.pilots.badge": "Programa Pré-Piloto · Cabo Verde",
  "home.pilots.title": "3 projetos-piloto para validar o modelo.",
  "home.pilots.text": "Nenhum projeto foi ainda executado. Os impactos apresentados são objetivos e hipóteses de validação — resultados quantitativos serão reportados apenas após implementação, monitorização e análise.",
  "home.partner.overline": "Escalável para África",
  "home.partner.title": "Construa a transição verde connosco.",
  "home.partner.text": "A BSGOTECH cresce através de parcerias estratégicas — tecnológicas, institucionais, de implementação local e investimento. As soluções validadas em Cabo Verde são replicáveis em mercados insulares e africanos.",
  "pillar.explore_more": "Explore o ecossistema.",
  "hero.slide.emobility": "Mobilidade elétrica alimentada a energia limpa.",
  "hero.slide.caboverde": "O nosso mercado de foco para validar a transição verde.",
  "cta.discuss": "Discutir um Projeto",
  "cta.explore": "Explorar Soluções",
  "cta.request_assessment": "Solicitar Avaliação de Projeto",
  "cta.explore_modular": "Explorar Modular",
  "cta.explore_energy": "Explorar Energia",
  "cta.explore_digital": "Explorar Digital",
  "cta.explore_integrated": "Explorar Soluções Integradas",
  "cta.view_project": "Ver Projeto",
  "cta.discuss_this": "Discutir Este Projeto",
  "cta.learn_more": "Saber mais",
  "tagline": "DIGITAL | MODULAR | ENERGIA",
  "brand.primary": "Tecnologia e infraestrutura para necessidades reais.",
  "brand.support": "Sistemas digitais, infraestrutura modular e soluções de energia fiáveis para empresas, comunidades e mercados em crescimento.",
  "home.cap.heading": "Três capacidades. Uma abordagem integrada.",
  "subtagline": "Infraestrutura prática. Energia fiável. Soluções integradas.",
  "corporate.message": "A construir soluções práticas para mercados em crescimento.",
  "hero.support": "Sediada em São Tomé e Príncipe, a BSGOTECH desenvolve soluções práticas modulares, de energia e integradas, ligando necessidades reais do mercado a parceiros internacionais especializados em tecnologia, fabrico, engenharia e implementação.",
  "home.digital.title": "Tecnologia que conecta.",
  "home.digital.text": "Websites · Apps · IA · Cloud · Automação",
  "home.capabilities": "Capacidades Principais",
  "home.modular.title": "Infraestrutura que se adapta.",
  "home.modular.text": "Infraestrutura modular flexível concebida em torno de necessidades práticas comerciais, comunitárias, institucionais e operacionais.",
  "home.energy.title": "Energia fiável onde é necessária.",
  "home.energy.text": "Geração, armazenamento, backup e sistemas de energia integrados configurados de acordo com requisitos reais do projeto.",
  "home.integrated.title": "Um projeto. Uma solução coordenada.",
  "home.integrated.text": "Infraestrutura, energia, tecnologia e implementação combinadas em torno de uma necessidade específica do projeto.",
  "hero.slide.energy": "Energia fiável onde é necessária.",
  "home.stp.title": "A construir a partir de casa.",
  "home.stp.text": "São Tomé e Príncipe é o mercado de origem e a base operacional inicial da BSGOTECH.",
  "process.title": "Como a BSGOTECH Trabalha",
  "model.title": "Necessidade local + Capacidade internacional + Implementação local = Solução prática",
  "concept": "Visual Conceptual",
  "section.overview": "Visão Geral",
  "section.need": "A Necessidade",
  "section.solution": "Solução BSGOTECH",
  "section.applications": "Aplicações",
  "section.configuration": "Configuração Possível",
  "section.architecture": "Arquitetura Modular",
  "section.energy": "Integração de Energia",
  "section.optional": "Componentes Opcionais",
  "section.implementation": "Processo de Implementação",
  "section.validation": "Validação Técnica",
  "section.assessment": "Solicitar Avaliação de Projeto",
  "disclaimer.short": "Configuração sujeita a avaliação técnica.",
  "disclaimer.long": "Dimensões finais, materiais, especificações, preços e cronograma de implementação dependem dos requisitos do projeto, localização, validação de engenharia e confirmação do parceiro de fabrico.",
  "projects.title": "Do conceito à implementação.",
  "projects.filter.all": "Todos",
  "footer.solutions": "Soluções",
  "footer.company": "Empresa",
  "footer.legal": "Legal",
  "footer.legal_notice": "Aviso Legal",
  "footer.imprint": "Ficha Legal",
  "footer.privacy": "Política de Privacidade",
  "footer.cookies": "Política de Cookies",
  "footer.faq": "Perguntas Frequentes",
  "footer.terms": "Termos",
  "footer.rights": "Todos os direitos reservados.",
  "contact.title": "O que precisa de construir?",
  "contact.submit": "Enviar Projeto",
  "contact.thankyou": "Obrigado. A BSGOTECH irá analisar os requisitos do seu projeto e contactá-lo sobre o próximo passo adequado.",
  "form.name": "Nome",
  "form.company": "Empresa / Organização",
  "form.country": "País",
  "form.email": "Email",
  "form.phone": "Telefone / WhatsApp",
  "form.looking_for": "Estou à procura de",
  "form.project_type": "Tipo de projeto",
  "form.location": "Localização do Projeto",
  "form.units": "Número Estimado de Unidades",
  "form.energy_req": "Requisito de Energia",
  "form.stage": "Fase do Projeto",
  "form.budget": "Orçamento",
  "form.timeline": "Prazo Pretendido",
  "form.description": "Descrição do Projeto",
  "whatsapp.default": "Olá BSGOTECH, gostaria de discutir um projeto.",
  "sec.services": "Serviços",
  "modular.hero.sub": "Espaços práticos. Infraestrutura flexível. A BSGOTECH desenvolve e configura soluções de infraestrutura modular com parceiros especializados de fabrico, engenharia e implementação — respondendo a necessidades locais reais, e não a produtos-contentor genéricos.",
  "modular.vc.overline": "Do Design à Entrega",
  "modular.vc.title": "Como uma solução modular BSGOTECH é entregue.",
  "energy.hero.sub": "Diga-nos o que precisa de alimentar. A BSGOTECH configura a solução — para casas, empresas e infraestruturas — com parceiros especializados de tecnologia e implementação de energia.",
  "energy.kits.overline": "Soluções de Energia BSGOTECH",
  "energy.kits.title": "Comece pelo que precisa de alimentar.",
  "energy.kits.sub": "Não precisa de escolher inversores ou capacidade de bateria primeiro. Escolha a sua situação e a BSGOTECH configura e valida a solução.",
  "energy.journey.title": "Diga-nos o que precisa de alimentar. A BSGOTECH configura a solução.",
  "energy.blocks.overline": "Componentes de Energia",
  "energy.blocks.title": "As tecnologias por trás das soluções.",
  "energy.apps.title": "Energia onde é importante.",
  "energy.partner.overline": "Ecossistema de Tecnologia de Energia",
  "energy.partner.title": "Tecnologia especializada, coordenada pela BSGOTECH.",
  "energy.partner.sub": "A MUST Energy aparece abaixo da oferta de energia da BSGOTECH, como parte do ecossistema de tecnologia e fabrico. A BSGOTECH configura a solução; os parceiros especializados fornecem a tecnologia.",
  "energy.provider.china": "Fornecedor de Tecnologia · China",
  "energy.must.role": "Parceiro de Tecnologia de Energia / Fabrico",
  "energy.must.note": "As capacidades refletem o catálogo e a relação com o fornecedor. Os produtos MUST Energy não são desenhados na Alemanha.",
  "energy.chain.1": "Avaliação de Energia e Configuração da Solução",
  "energy.chain.2": "Tecnologia de Energia e Fabrico",
  "energy.chain.3": "Entrega Internacional",
  "energy.chain.4": "Instalação · Integração · Suporte",
  "logistics": "Logística",
  "delivery.overline": "Solicitar Estimativa de Entrega",
  "delivery.title": "Da avaliação à instalação.",
  "delivery.note": "Os dias/semanas estimados são apresentados apenas após a confirmação do fornecedor e da logística para o projeto específico. Não publicamos prazos fixos de fabrico ou envio.",
  "ivc.overline": "Uma Cadeia de Valor Internacional",
  "ivc.title": "Do design à entrega local.",
  "ivc.intro": "A BSGOTECH desenvolve e configura soluções completas e recorre a parceiros internacionais especializados de tecnologia e fabrico para as entregar.",
  "ivc.dev": "Desenvolvimento · Integração · Automação",
  "digital.hero.sub": "Tecnologia que conecta. A BSGOTECH concebe e coordena soluções digitais — websites, aplicações, IA, cloud e automação — entregues com parceiros tecnológicos especializados.",
  "digital.services.title": "Digital, configurado em torno da necessidade.",
  "digital.eco.overline": "Ecossistema de Tecnologia Digital",
  "digital.eco.title": "Construído com parceiros especializados.",
  "digital.eco.sub": "A BSGOTECH desenvolve e coordena a solução. Parceiros tecnológicos especializados apoiam a entrega.",
  "digital.provider": "Fornecedor de Tecnologia",
  "digital.aaban.role": "Parceiro Tecnológico · Software",
  "digital.aaban.note": "A Aaban Solutions é um parceiro tecnológico especializado e não uma divisão da BSGOTECH.",
  "kit.solution.label": "Solução de Energia BSGOTECH",
  "kit.arch": "Arquitetura Possível da Solução",
  "kit.assessment": "Avaliação",
  "kit.discuss": "Discutir este projeto",
  "kit.fullkit": "Um Kit de Energia Completo BSGOTECH é uma solução configurada, não uma bateria ou inversor fabricado pela BSGOTECH.",
  "kit.finalsizing": "O dimensionamento final requer validação técnica.",
  "kit.infra.text": "A energia de infraestrutura é configurada em conjunto com a infraestrutura modular. Fale-nos do seu projeto e a BSGOTECH configura a solução integrada.",
  "kit.thankyou": "Obrigado. A BSGOTECH irá analisar os seus requisitos e contactá-lo com uma solução configurada. O dimensionamento final requer validação técnica.",
  "assess.contact": "WhatsApp / Email",
  "assess.error": "Por favor, indique o seu nome e contacto (WhatsApp / Email).",
  "int.hero.l1": "MAIS DO QUE INFRAESTRUTURA.",
  "int.hero.l2": "MAIS DO QUE ENERGIA.",
  "int.hero.l3": "UMA SOLUÇÃO COORDENADA.",
  "int.hero.p": "A BSGOTECH pode configurar diferentes componentes em torno de um projeto, em vez de tratar a infraestrutura e a energia como compras completamente separadas.",
  "int.examples.overline": "Exemplos",
  "int.examples.title": "Arquiteturas de solução configuráveis.",
  "int.examples.sub": "Estas são arquiteturas de solução configuráveis, não pacotes técnicos fixos.",
  "int.connected.overline": "Soluções Conectadas",
  "int.connected.title": "Modular + Energia + Digital, em conjunto.",
  "int.connected.sub": "Arquiteturas conectadas configuráveis — não pacotes técnicos fixos.",
  "int.partnermodel.overline": "Modelo de Parceria Internacional",
  "int.partnermodel.title": "Como as capacidades se juntam.",
  "partners.overline": "Ecossistema de Parceiros",
  "partners.hero.title": "CONSTRUÍDO ATRAVÉS DE PARCERIAS ESPECIALIZADAS.",
  "partners.hero.sub": "O papel da BSGOTECH é ligar as capacidades adequadas em torno de cada projeto, em vez de afirmar que fabrica cada componente internamente.",
  "partners.categories": "Categorias",
  "partners.cat.title": "Um ecossistema coordenado.",
  "partners.rel.overline": "Relações",
  "partners.rel.title": "Estado atual dos parceiros.",
  "partners.rel.sub": "Apenas são apresentadas relações adequadas para exibição pública. O estado reflete a fase real de cada conversa.",
  "partners.empty": "Ainda não há parceiros publicados.",
  "about.hero.sub": "A BSGOTECH é uma empresa sediada em São Tomé e Príncipe focada no desenvolvimento de soluções práticas de infraestrutura modular, de energia e integradas.",
  "about.p1": "O nosso modelo combina o conhecimento do mercado local com capacidades internacionais especializadas de fabrico, engenharia, energia e tecnologia.",
  "about.p2": "Desde a identificação de uma necessidade até à configuração da solução, coordenação de parceiros e implementação, a BSGOTECH procura construir soluções práticas, escaláveis e adequadas ao seu ambiente operacional.",
  "about.principles.overline": "Princípios",
  "about.principles.title": "Cinco princípios.",
  "about.bm.overline": "Modelo de Negócio",
  "about.bm.title": "Da necessidade de mercado ao suporte.",
  "about.ipm.title": "Local + internacional + local.",
  "about.ipm.p": "Necessidade local + capacidade internacional + implementação local = solução prática.",
  "about.germany.overline": "Alemanha & Europa",
  "about.germany.tag": "Tecnologia · Engenharia · Fabrico · Desenvolvimento de Negócio · Parcerias",
  "about.germany.p": "A BSGOTECH pode desenvolver relações com parceiros europeus de tecnologia, engenharia, fabrico e comerciais. A BSGOTECH não é uma empresa alemã e não mantém uma sede corporativa na Alemanha.",
  "about.africa.overline": "Mercados Africanos Selecionados",
  "about.africa.tag": "Crescimento liderado por parceiros.",
  "about.africa.p": "A BSGOTECH pretende avaliar oportunidades em mercados africanos selecionados com base na procura real do mercado, parceiros locais, viabilidade técnica, viabilidade comercial, financiamento e capacidade de implementação.",
  "about.local.overline": "Construir Capacidade Local",
  "about.local.tag": "Um objetivo de desenvolvimento.",
  "about.local.p": "Onde for técnica e comercialmente viável, os projetos da BSGOTECH podem apoiar progressivamente a instalação local, montagem, formação técnica, capacidade de manutenção, participação de fornecedores, desenvolvimento de competências e transferência de conhecimento.",
  "model.need": "NECESSIDADE LOCAL",
  "model.intl": "CAPACIDADE INTERNACIONAL",
  "model.localimpl": "IMPLEMENTAÇÃO LOCAL",
  "model.result": "= SOLUÇÃO PRÁTICA",
};

const de = {
  "nav.home": "Start",
  "nav.modular": "Modular",
  "nav.energy": "Energie",
  "nav.digital": "Digital",
  "nav.integrated": "Lösungen",
  "nav.projects": "Projekte",
  "nav.divisions": "Bereiche",
  "nav.partners": "Partner",
  "nav.about": "Über uns",
  "nav.contact": "Kontakt",
  "nav.solutions": "Lösungen",
  "nav.integrated_full": "Integrierte Lösungen",
  "nav.pilots": "Pilotprojekte",
  "nav.caboverde": "Kap Verde",
  "nav.technology": "Technologie",
  "nav.gallery": "Galerie",
  "nav.projectmap": "Carte des projets",
  "cta.become_partner": "Partner werden",
  "cta.explore_solutions": "Lösungen entdecken",
  "cta.know_pilots": "Pilotprojekte ansehen",
  "cta.discuss": "Projekt besprechen",
  "cta.explore": "Lösungen entdecken",
  "cta.request_assessment": "Projektbewertung anfordern",
  "tagline": "DIGITAL | MODULAR | ENERGIE",
  "subtagline": "Praktische Infrastruktur. Zuverlässige Energie. Integrierte Lösungen.",
  "corporate.message": "Praktische Lösungen für wachsende Märkte.",
  "contact.title": "Was möchten Sie bauen?",
  "contact.submit": "Projekt senden",
};

const fr = {
  "nav.home": "Accueil",
  "nav.modular": "Modulaire",
  "nav.energy": "Énergie",
  "nav.digital": "Digital",
  "nav.integrated": "Solutions",
  "nav.projects": "Projets",
  "nav.divisions": "Divisions",
  "nav.partners": "Partenaires",
  "nav.about": "À propos",
  "nav.contact": "Contact",
  "nav.solutions": "Solutions",
  "nav.integrated_full": "Solutions intégrées",
  "nav.pilots": "Pilotes",
  "nav.caboverde": "Cap-Vert",
  "nav.technology": "Technologie",
  "nav.gallery": "Galerie",
  "nav.projectmap": "Carte des projets",
  "cta.become_partner": "Devenir partenaire",
  "cta.explore_solutions": "Explorer les solutions",
  "cta.know_pilots": "Découvrir les pilotes",
  "cta.discuss": "Discuter d'un projet",
  "cta.explore": "Explorer les solutions",
  "cta.request_assessment": "Demander une évaluation",
  "tagline": "DIGITAL | MODULAIRE | ÉNERGIE",
  "subtagline": "Infrastructure pratique. Énergie fiable. Solutions intégrées.",
  "corporate.message": "Des solutions pratiques pour les marchés en croissance.",
  "contact.title": "Que devez-vous construire ?",
  "contact.submit": "Envoyer le projet",
};

export const TRANSLATIONS = { en, pt, de, fr };
